module.exports = __webpack_public_path__ + "33ce10d65d727bee2d9d09e6db65eab5.png";